import { WalletKyc } from '../../../schemas/wallet-kyc-schema';
import { request } from '../../../utils/request';

export default function submitKycDocuments(props: {
  customer_id: number;
  authToken: string;
  documents: Record<keyof WalletKyc['documents'], string>;
}) {
  return request({
    url: `/sterling/kyc/corporate/${props.customer_id}/documents`,
    method: 'POST',
    formData: props.documents,
    headers: { Authorization: `Bearer ${props.authToken}` },
  });
}
